enum AuthenticationType {
  DATA_STORE = 'DataStore',
  KERBEROS = 'Kerberos',
  LDAP = 'LDAP',
  SAML = 'SAML',
  XML = 'XML',
}

export default AuthenticationType;
